import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useFetchDashboardIsuueDetailsQuery, useFetchIssueModuleQuery } from "../../slice/logdetailSlice";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader";
import { useSelector } from "react-redux";
import { FaUser } from "react-icons/fa";
// import { format } from "date-fns";
import { CustomNoRowsOverlay } from "../common/OverlayGrid";
import { Box } from "@mui/system";
import dayjs from "dayjs";

const DynamicTable = ({ onSeeMore }) => {
  const navigate = useNavigate();
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const login_user_role = login_user?.role;
  const isFetchedRole = !!login_user_role;
  // const isEmployee = login_user_role === "EMPLOYEE";
    
  // Both Employee and Contractor should typically see only their issues
  const isEmployeeOrContractor = login_user_role === "EMPLOYEE" || login_user_role === "CONTRACTOR";


  const {
    data: adminIssues,
    isLoading: adminLoading,
    refetch: refetchAdmin,
  } = useFetchDashboardIsuueDetailsQuery(undefined, {
    // skip: isEmployee,
    // skip: !isFetchedRole || isEmployee,
      skip: !isFetchedRole || isEmployeeOrContractor,
  });

  const {
  //    data: issue_detail,
  //    isLoading: issue_loading,
  //    refetch: issue_refetch,
  //  } = useFetchDashboardIsuueDetailsQuery();
    data: employeeIssues,
    isLoading: employeeLoading,
    refetch: refetchEmployee,
  } = useFetchIssueModuleQuery(
    { view_type_id: 6 },
    {
      // skip: !isEmployee,
      // skip: !isFetchedRole || !isEmployee,
            skip: !isFetchedRole || !isEmployeeOrContractor,
    }
  );

  // const issue_loading = isEmployee ? employeeLoading : adminLoading;
  // const issue_loading = !isFetchedRole || (isEmployee ? employeeLoading : adminLoading);
    const issue_loading = !isFetchedRole || (isEmployeeOrContractor ? employeeLoading : adminLoading);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  // const navigate = useNavigate();
  // const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // const { role: login_user_role } = login_user;

  // useEffect(() => {
  //   issue_refetch();
  // }, []);

  useEffect(() => {
    if (isFetchedRole) {
      // if (isEmployee) {
      if (isEmployeeOrContractor) {
        refetchEmployee();
      } else {
        refetchAdmin();
      }
  // }, [isEmployee]);
    }
  // }, [isFetchedRole, isEmployee]);
    }, [isFetchedRole, isEmployeeOrContractor]);

  const rows = React.useMemo(() => {
    if (!isFetchedRole) return [];
    // if (isEmployee) {
        
    // Employee & Contractor will use employeeIssues
    if (isEmployeeOrContractor) {
      const flatIssues = [];
      if (employeeIssues) {
        employeeIssues.forEach((item) => {
          const projectTitle = item.project?.title || "";
          if (Array.isArray(item.issues)) {
            item.issues.forEach((issue) => {
              flatIssues.push({
                id: issue.issue_id,
                issue_id: issue.issue_id,
                name: issue.title,
                status_name: issue.current_status_name,
                status_colour: issue.status_colour,
                project_name: projectTitle,
                assignee: issue.assignee_name,
                reporter_name: issue.reporter_name,
                create_date: issue.added_at,
                project_id: issue.project_id,
              });
            });
          }
        });
      }
      return flatIssues;
    } else {
      // For Admin, Manager, and Client we rely on the adminIssues data for now 
      // (Backend should apply specific logic based on their token if available)
      return adminIssues || [];
    }
  // }, [isEmployee, employeeIssues, adminIssues]);
  // }, [isFetchedRole, isEmployee, employeeIssues, adminIssues]);
    }, [isFetchedRole, isEmployeeOrContractor, employeeIssues, adminIssues]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
    },
    {
      field: "name",
      headerName: "Issue",
      width: 250,
    },
    {
      field: "status_name",
      headerName: "Status",
      width: 120,
      renderCell: (params) => (
        <span style={{ color: params.row.status_colour || "black" }}>
          {params.row.status_name}
        </span>
      ),
    },
    {
      field: "project_name",
      headerName: "Project",
      width: 180,
    },
    {
      field: "assignee",
      headerName: "Assignee",
      width: 210,
      renderCell: (params) => (
        <span style={{ color: "rgba(195, 195, 195, 1)" }}>
          <FaUser className="me-2" />
          {params.row.assignee}
        </span>
      ),
    },
    {
      field: "reporter_name",
      headerName: "Reporter",
      width: 210,
      renderCell: (params) => (
        <span style={{ color: "rgba(195, 195, 195, 1)" }}>
          <FaUser className="me-2" />
          {params.row.reporter_name || "Unassigned"}
        </span>
      ),
    },
    {
      field: "create_date",
      headerName: "Create Date",
      width: 170,
      renderCell: (params) => {
        // console.log("params :", params);
        const Date = dayjs(params.value).format("DD/MM/YYYY");
        return <Box>{Date}</Box>;
      },
    },
  ];

  // Logic to display role-based titles
  let issueTitle = "All Issues"; // Default for Admin
  if (login_user_role === "EMPLOYEE" || login_user_role === "CONTRACTOR") {
    issueTitle = "My Issues";
  } else if (login_user_role === "MANAGER") {
    issueTitle = "Project Issues";
  } else if (login_user_role === "CLIENT") {
    issueTitle = "My Project Issues";
  }

  return (
    <>
      {issue_loading ? (
        <Loader />
      ) : (
        <div className="bg-white p-3 rounded-3">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <h5 className="cardsub_title mb-0 pe-3">
                {/* {login_user_role === "ADMIN" || login_user_role === "CLIENT"
                  ? "All Issues"
                  : "My Issues"} */}
                {/* {isEmployee ? "My Issues" : "All Issues"} */}

                 {/* Logic to display role-based titles */}
                 {issueTitle}
              </h5>
              <div className="cardsub_title_line"></div>
            </div>
          </div>

          <div style={{ height: 500, width: "100%" }} className="tableScroll">
            <DataGrid
              // rows={issue_detail || []}
              rows={rows}
               // rows={rows || []}
              columns={columns}
              getRowId={(row) => row.id}
              pagination
              paginationModel={paginationModel}
              slots={{ noRowsOverlay: CustomNoRowsOverlay }}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 25, 50, 100]}
              // onRowClick={(params) =>
              onRowClick={(params) => {
                if (login_user_role !== "CLIENT") {
                  navigate(
                    `/projects/projectDetail/${params.row.project_id}/issue/IssueDetail/${params.row.id}`
                  );
                }
              }}
              sx={{
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f5f5f5",
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-row": {
                  cursor: login_user_role === "CLIENT" ? "default" : "pointer",
                },
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DynamicTable;
